import { createContext, useContext } from 'react';

import type { PickerSize } from '../pickerPrimitiveStyles';

type SelectContextValue = {
  size: PickerSize;
  isLoading?: boolean;
  error?: Error | null;
};

const SelectContext = createContext<SelectContextValue>({
  size: 'large',
  isLoading: false,
  error: null,
});

export const useSelectContext = () => useContext(SelectContext);

export default SelectContext;
